@if (imports().length > 0) {
	<div class="import-banner" [class.import-banner--expanded]="expanded()">
		<!-- Summary row — always visible -->
		<div class="import-banner__summary" (click)="toggleExpanded()" (keydown.enter)="toggleExpanded()" tabindex="0" role="button" data-testid="import-progress-summary-toggle">
			<i [ngClass]="summaryIcon()" class="import-banner__icon" [class.pi-spin]="isActive" [class.import-banner__icon--done]="allDone"></i>
			<span class="import-banner__label" data-testid="import-progress-summary-label">{{ summaryLabel }}</span>

			@if (imports().length > 1 && allDone) {
				<!-- Collapsed multi-import: show a done tag so completion is visible without expanding -->
				<p-tag [value]="summaryTagValue" [severity]="summaryTagSeverity" class="import-banner__tag" />
			}

			@if (imports().length === 1) {
				<p-tag [value]="tagValue(imports()[0].status)" [severity]="tagSeverity(imports()[0].status)" class="import-banner__tag" />
				@if (showProgressBar(imports()[0])) {
					@if (imports()[0].status !== 'PREPARING' && imports()[0].status !== 'COMPLETED') {
						<span class="import-banner__summary-count">{{ imports()[0].documentsIndexed }} / {{ imports()[0].totalDocuments }}</span>
					}
					<p-progressbar
						[value]="imports()[0].status === 'PREPARING' ? 0 : progressPercent(imports()[0])"
						[mode]="imports()[0].status === 'PREPARING' ? 'indeterminate' : 'determinate'"
						class="import-banner__progress-mini"
						[class.import-banner__progress-mini--done]="imports()[0].status === 'COMPLETED'"
						[showValue]="false"
					/>
				}
			}

			<i class="pi import-banner__chevron" [class.pi-chevron-up]="expanded()" [class.pi-chevron-down]="!expanded()"></i>
		</div>

		<!-- Expanded detail — single import -->
		@if (expanded() && imports().length === 1) {
			<div class="import-banner__detail">
				<span class="import-banner__detail-status" data-testid="import-progress-detail-status">{{ statusLabel(imports()[0]) }}</span>
				@if (showProgressBar(imports()[0])) {
					<p-progressbar
						[value]="imports()[0].status === 'PREPARING' ? 0 : progressPercent(imports()[0])"
						[mode]="imports()[0].status === 'PREPARING' ? 'indeterminate' : 'determinate'"
						class="import-banner__progress-full"
						[class.import-banner__progress-full--done]="imports()[0].status === 'COMPLETED'"
						[showValue]="false"
					/>
				}
			</div>
		}

		<!-- Expanded list — multiple imports -->
		@if (expanded() && imports().length > 1) {
			<div class="import-banner__list">
				@for (imp of imports(); track imp.mainSuiteId) {
					<div class="import-banner__item" [attr.data-testid]="'import-progress-item-row-' + imp.mainSuiteId">
						<div class="import-banner__item-header">
							<span class="import-banner__item-name" data-testid="import-progress-item-name">{{ imp.mainSuiteName || imp.mainSuiteId }}</span>
							<p-tag [value]="tagValue(imp.status)" [severity]="tagSeverity(imp.status)" class="import-banner__tag" />
						</div>
						<span class="import-banner__item-status" data-testid="import-progress-item-status">{{ statusLabel(imp) }}</span>
						@if (showProgressBar(imp)) {
							<p-progressbar
								[value]="imp.status === 'PREPARING' ? 0 : progressPercent(imp)"
								[mode]="imp.status === 'PREPARING' ? 'indeterminate' : 'determinate'"
								class="import-banner__progress-full"
								[class.import-banner__progress-full--done]="imp.status === 'COMPLETED'"
								[showValue]="false"
							/>
						}
					</div>
				}
			</div>
		}
	</div>
}
